import { useEffect, useRef, useState } from 'react';

const SCROLL_THRESHOLD = 100;

export const useTopbarScrollAway = () => {
  const contentRef = useRef(null);
  const lastScrollTop = useRef(0);
  const [isTopbarAnimatedOut, setIsTopbarAnimatedOut] = useState(true);

  useEffect(() => {
    const currentElement = contentRef?.current;
    const handleScroll = () => {
      const scrollTop = currentElement.scrollTop;
      const lastValue = lastScrollTop.current;
      lastScrollTop.current = scrollTop;
      setIsTopbarAnimatedOut(scrollTop <= SCROLL_THRESHOLD || scrollTop - lastValue <= 0);
    };

    if (!currentElement) return;

    currentElement.addEventListener('scroll', handleScroll);

    return () => {
      currentElement.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return { contentRef, isTopbarAnimatedOut };
};

export default useTopbarScrollAway;
